import type { StepConfig } from "@portal/components/multiform/types";
import { BondAdditionalInfoStep } from "../../../../account/create/steps/bond-additional-info/BondAdditionalInfoStep";
import type { AdminBondRequestFormData } from "../../schema";
import { BondAdditionalInfoSummary } from "./BondAdditionalInfoSummary";

export const bondAdditionalInfoStepConfig: StepConfig<AdminBondRequestFormData> = {
	name: "bondAdditionalInfo",
	label: "Bond Info",
	fieldPaths: ["quote.additionalInfo"],
	component: BondAdditionalInfoStep,
	summaryComponent: BondAdditionalInfoSummary,
};
